import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './assets/Global.css'
import './assets/ResponsiveUtilities.css'
// Import axios interceptor (must be after other imports, but before app.use(pinia) is fine since interceptor callback runs later)
import './utils/axios'

loadFonts()

const app = createApp(App)
const pinia = createPinia()

app.use(router)
app.use(vuetify)
app.use(pinia)
app.mount('#app')
